module.exports = __webpack_public_path__ + "static/fonts/Fact-SemiExpandedBold.20f34b7.woff2";